/**
 * Owner: Masa Bayu
 * File: adapter.ts
 * Date:Time: 2026-10-05 14:02
 * Description: Fasa 19 · UniversalAtom → FlatAtom for Structural Classifier.
 */

import type { UniversalAtom } from './types';

/** Classifier-facing flat geometry (matches @qx/spsu-structural-classifier). */
export interface FlatAtom {
  id: string;
  type: 'text' | 'image' | 'vector';
  x: number;
  y: number;
  width: number;
  height: number;
  text?: string;
  fontSize?: number;
  assetId?: string;
}

export function adaptToClassifier(atom: UniversalAtom): FlatAtom {
  const flat: FlatAtom = {
    id: atom.id,
    type: atom.type,
    x: atom.bbox.x,
    y: atom.bbox.y,
    width: atom.bbox.width,
    height: atom.bbox.height,
  };

  if (atom.type === 'text') {
    if (atom.textContent !== undefined) {
      flat.text = atom.textContent;
    }
    if (atom.font !== undefined) {
      flat.fontSize = atom.font.size;
    }
  }

  if (atom.assetId !== undefined) {
    flat.assetId = atom.assetId;
  }

  return flat;
}
